import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { GlobalComponent } from 'src/app/global/global.component';
// import { generalservice } from 'src/app/services/general.service';
import { map, catchError, retry } from 'rxjs/operators';
import { getgrid } from './client-onboardinglist.model';
import { GeneralService } from 'src/app/service/general.service';
import { GetListBase } from '../client-onboarding/client-onboarding.model';

@Injectable({
  providedIn: 'root'
})
export class ClientOnboardService extends Subject<DataStateChangeEventArgs> {
  constructor(private http: HttpClient, public global: GlobalComponent, public general:GeneralService) {
    super();
  }
  

  public exceuteAgency(state: GetListBase): void {
    this.getDocumentListAgency(state).subscribe(x => super.next(x));
  }
  getDocumentListAgency(state?: GetListBase): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/ClientAgreement/GetClientsDocumentListForAgency", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['pageCount']
          }
      ))

  }

  public exceuteportal(state: GetListBase): void {
    this.getDocumentListPortal(state).subscribe(x => super.next(x));
  }
  getDocumentListPortal(state?: GetListBase): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Client_ClientAgreement/GetClientsDocumentListForPortal", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['pageCount']
          }
      ))

  }
  

}
